export default {
  lang: {
    selectAll: 'Pumili ang lahat ng pahinan',
    selected: 'Pinilin',
    term: 'Artikulo',
    deselect: 'Undelect',
  },
};
